import { createHashRouter, type RouteObject } from 'react-router';

import { RouteErrorBoundary } from '@/components/root-error-boundary';
import { HomePage } from '@/routes/home';
import { ProtectedLayout } from '@/routes/protected-layout';
import { TemplateEditPage } from '@/routes/template-edit';
import { TemplateNewPage } from '@/routes/template-new';

/**
 * Declarative route tree. Hash routing per D11 / D47 — every route path
 * is per-document via the URL fragment, so embedding inside WFM or an
 * Evo MFE host doesn't conflict with the parent's path.
 *
 * Phase 2 wires the tree; Phase 4 replaces `ProtectedLayout` with the
 * real shell; Plans 2 and 3 fill in the page contents.
 */
export const routes: RouteObject[] = [
  {
    path: '/',
    Component: ProtectedLayout,
    // Catches any uncaught render error in the subtree and shows a friendly
    // fallback instead of react-router's default error screen — matters when
    // embedded in a host (WFM).
    ErrorBoundary: RouteErrorBoundary,
    children: [
      { index: true, Component: HomePage },
      { path: 'templates/new', Component: TemplateNewPage },
      { path: 'templates/:templateId', Component: TemplateEditPage },
    ],
  },
];

export const hashRouter = createHashRouter(routes);
